import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'eng-qr-code',
  imports: [],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent implements AfterViewInit {
  @ViewChild('qrShareCodePlaceholder')
  private qrShareCodePlaceholder?: ElementRef;

  private _text = '';

  public qrCode!: QRCode;

  @Input()
  public set text(value: string) {
    this._text = value;
    this.initQrCode(value);
  }

  public get text(): string {
    return this._text;
  }

  public ngAfterViewInit(): void {
    this.initQrCode(this.text);
  }

  public initQrCode(text: string) {
    if (!this.qrShareCodePlaceholder) {
      return;
    }

    if (!this.qrCode) {
      this.qrCode = new QRCode(this.qrShareCodePlaceholder.nativeElement, {
        text: text,
        width: 128,
        height: 128,
        colorDark: '#000000',
        colorLight: '#ffffff',
        typeNumber: 10,
        correctLevel: QRCode.CorrectLevel.L,
      });
    } else {
      this.qrCode.clear();
      this.qrCode.makeCode(text);
    }
  }
}
